import React, { useContext, useState } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { DataContext } from "../../../js/App";
import './standard.scss';

const Standard = ({ name, fieldLabel, type, placeholder, labelPlaceholder, defaultValue }) => {
  const context = useContext(DataContext);
  const { handleChange, removeMultipleValues } = context;

  const [incidentDateError, setIncidentDateError] = useState(false);

  const handleDateChange = e => {
    if(name === 'incidentDate'){
      const incidentDate = new Date(e.target.value);
      const now = new Date();
      
      if(now < incidentDate){
        setIncidentDateError(true);
        const incidentDateEntry = {};
        incidentDateEntry[name] = "";
        removeMultipleValues(incidentDateEntry);
      } else {
        setIncidentDateError(false);
        handleChange(e);
      }
    } else {
      handleChange(e);
    }
  }

  return (
    <Form.Group as={Row} className="mb-3" controlId="standardFieldGroup">
      {fieldLabel && (
        <Form.Label column sm="5">
          {fieldLabel}
          {labelPlaceholder && (<span className="label-placeholder" dangerouslySetInnerHTML={{__html: placeholder}}></span>)}
        </Form.Label>
      )}
      <Col sm={fieldLabel !== null ? "7" : "12"}>
        {type === "textarea" ? (
          <Form.Control
            name={name}
            onChange={handleChange}
            as="textarea"
            style={{ height: "100px" }}
            placeholder={!labelPlaceholder ? placeholder : ""}
          />
        ) : (<>
          <Form.Control
            name={name}
            onChange={e => {if(type === "date") {handleDateChange(e)} else {handleChange(e)}}}
            type={type}
            placeholder={!labelPlaceholder ? placeholder : ""}
            isInvalid={type === "date" ? (incidentDateError === true ? true : false) : false}
            defaultValue={defaultValue}
          />
          <Form.Control.Feedback type="invalid">
            Date of incident cannot be in the future.
          </Form.Control.Feedback>
          </>
        )}
      </Col>
    </Form.Group>
  );
};

export default Standard;
